module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_5012.1cb64f46.png";